import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { Witoil } from './app.component';
import { HomePage } from '../pages/home/home';
import { NomobilePage } from '../pages/nomobile/nomobile';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';

// Providers
import { MenuProvider } from '../providers/menu/menu';
import { CommonProvider } from '../providers/common/common';
import { PouchdbProvider } from '../providers/pouchdb/pouchdb';

// Tooltips
import { TooltipsModule } from 'ionic-tooltips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Translations
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UtilsProvider } from '../providers/utils/utils';

// import { FileTransfer } from '@ionic-native/file-transfer'; 
// import { FileTransferObject } from '@ionic-native/file-transfer'; 
// import { File } from '@ionic-native/file'; 
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}



@NgModule({
  declarations: [
    Witoil,
    HomePage,
    NomobilePage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(Witoil),
    IonicStorageModule.forRoot(),
    TooltipsModule.forRoot(),
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
           provide: TranslateLoader,
           useFactory: (createTranslateLoader),
           deps: [HttpClient]
         }
      })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    Witoil,
    HomePage,
    NomobilePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    HttpClientModule,
    MenuProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    CommonProvider,
    PouchdbProvider,
    UtilsProvider,
    FileTransfer, 
    FileTransferObject, 
    // File
  ]
})



export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts